// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393889364181",
  numero_telefono: "tel:+393889364181",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  */

  urlWeb: 'https://discentya.formedilcaserta.it/',
  urlMaterialeDidattico: 'https://discentya.formedilcaserta.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.formedilcaserta.it/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.formedilcaserta.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.formedilcaserta.it/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.formedilcaserta.it/api/',

  urlStampa: 'https://discentya.formedilcaserta.it/stampe/',

  urlAttestati: 'https://discentya.formedilcaserta.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.formedilcaserta.it/pages/certificate/',
  urlImagePartners: 'https://discentya.formedilcaserta.it/assets/media/partners/',

};

